<template lang="pug">
	.element-events-add(v-show="showed" :style="position" v-pseudo-modal-name="'element-events-add'")
		MultiLevelDropdownMenu(ref="dropdownMenu" @change="addEvent($event.item, $event.data)")
</template>

<script>
	import Screen from './../../mixins/screen'

	import MultiLevelDropdownMenu from './../UI/MultiLevelDropdownMenu'

	export default {
		name: 'EditorElementInfoEventsAdd',
		mixins: [Screen],
		screen: {
			updateOn: [
				"Selected Element Switched",
				"Selected Element Event Added",
				"Selected Element Event Removed",
				"Global Event Added",
				"Global Event Removed"
			],
			events: {
				"Show EditorElementInfoEventsAdd": function(el, element) {

					this.element = element;

					let rect = el.getBoundingClientRect();

					this.position.right = (document.body.clientWidth - rect.right) + 'px';
					this.position.bottom = (document.body.clientHeight - rect.bottom) + 'px';

					this.update();

				},
				// Клик в любом месте кроме контента помеченного element-events-add - закрывает компонент
				"Pseudo Modal Process Hide": function(names) {

					if (!_.includes(names, 'element-events-add') && this.showed) {

						this.close();

					}

				}
			}
		},
		components: {
			MultiLevelDropdownMenu
		},
		props: [],
		data() {

			this.target = null;
			this.element = null;
			this.events = [];

			return {
				position: {
					right: 0,
					bottom: 0
				}
			};

		},
		methods: {
			collectData() {

				if (!Version.SelectedVersion) return;

				let eventItemsTree = [];

				this.screen = ScreenService.SelectedScreen;
				this.element = Elements.SelectedElement;

				if (Elements.SelectedElement?.type === 'global') this.target = 'global';
				else if (Elements.SelectedElement?.type === 'root-container') this.target = 'screen';
				else if (Elements.SelectedElement) this.target = 'element';

				if (this.target === 'element') {

					if (!this.element) return;

					let elementEventsByCodename = _.keyBy(Events.getEvents(this.element["version_id"], this.element["screen_codename"], this.element["codename"]) || [], 'codename');

					eventItemsTree = _.map(_.orderBy(_.filter(Metadata.Events, eventProps => eventProps.target === this.target && (!eventProps.options.elementTypes || _.includes(eventProps.options.elementTypes, this.element.type)) && eventProps.section === 'general'), 'priority'), eventProps => {
						return {..._.pick(eventProps, ['title', 'description']), width: 200, disabled: elementEventsByCodename[eventProps.codename] || !eventProps.active, data: {eventCodename: eventProps.codename}}
					});

					if (this.element.type === 'video') {

						let playbackEvent = {
							title: "Playback", description: "Video element playback events", width: 200, childs: _.map(_.orderBy(_.filter(Metadata.Events, eventProps => eventProps.target === this.target && eventProps.section === 'playback'), 'priority'), eventProps => {
								return {..._.pick(eventProps, ['title', 'description']), width: 200, disabled: elementEventsByCodename[eventProps.codename] || !eventProps.active, data: {eventCodename: eventProps.codename}}
							})
						};

						eventItemsTree.push(playbackEvent);

					}

				} else if (this.target === 'screen') {

					let elementEventsByCodename = _.keyBy(Events.getScreenEvents(Version.SelectedVersion.id, this.screen.codename) || [], 'codename');

					eventItemsTree = _.map(_.orderBy(_.filter(Metadata.Events, eventProps => eventProps.target === this.target), 'priority'), eventProps => {
						return {..._.pick(eventProps, ['title', 'description']), width: 200, disabled: elementEventsByCodename[eventProps.codename] || !eventProps.active, data: {eventCodename: eventProps.codename}}
					});

				} else if (this.target === 'global') {

					let elementEventsByCodename = _.keyBy(Events.getGlobalEvents(Version.SelectedVersion.id) || [], 'codename');

					eventItemsTree = _.map(_.orderBy(_.filter(Metadata.Events, eventProps => eventProps.target === this.target && eventProps.section === 'general'), 'priority'), eventProps => {
						return {..._.pick(eventProps, ['title', 'description']), width: 200, disabled: elementEventsByCodename[eventProps.codename] || !eventProps.active, data: {eventCodename: eventProps.codename}}
					});

					let viewableEvent = {title: "Viewable", description: "The creative was viewed for <n> seconds", width: 200, childs: _.map(_.orderBy(_.filter(Metadata.Events, eventProps => eventProps.target === this.target && eventProps.section === 'viewable'), 'priority'), eventProps => {
						return {..._.pick(eventProps, ['title', 'description']), width: 200, disabled: elementEventsByCodename[eventProps.codename] || !eventProps.active, data: {eventCodename: eventProps.codename}}
					})};

					eventItemsTree.push(viewableEvent);

				}

				if (this.$refs.dropdownMenu) this.$refs.dropdownMenu.setItems(eventItemsTree);

			},
			addEvent(item, data = {}) {

				if (this.target === 'global') {

					Server.sendToSocket({
						AddGlobalEvent: {
							versionId: Version.SelectedVersion.id,
							eventCodename: data.eventCodename
						}
					});

				} else if (this.target === 'screen') {

					Server.sendToSocket({
						AddScreenEvent: {
							screenId: ScreenService.SelectedScreen.id,
							eventCodename: data.eventCodename
						}
					});

				} else if (this.target === 'element') {

					Server.sendToSocket({
						AddEvent: {
							elementId: Elements.SelectedElement.id,
							eventCodename: data.eventCodename
						}
					});

				}

				this.close();

			},
			close() {

				if (this.$refs.dropdownMenu) this.$refs.dropdownMenu.close();

				this.hide();

			}
		}
	}
</script>

<style lang="sass">

	.element-events-add
		position: absolute
		user-select: none

</style>
